import React from 'react';
import UISkeleton from 'react-loading-skeleton';
import ArrayUtils from 'app/utils/array';

const SKELETON_ROW_COUNT = 8;

const InstagramAudioTrackListSkeleton = () => (
  <div className="tw-flex tw-flex-col tw-gap-2">
    {ArrayUtils.generate(SKELETON_ROW_COUNT).map((index) => (
      <div key={index} className="tw-flex tw-items-center tw-gap-3 tw-p-2">
        <UISkeleton width={40} height={40} borderRadius={6} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1">
          <UISkeleton width="40%" height={14} />
          <UISkeleton width="25%" height={12} />
        </div>
      </div>
    ))}
  </div>
);

export default InstagramAudioTrackListSkeleton;
